import { useEffect, useState } from "react";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import { QRCodeCanvas } from "qrcode.react";
import EntradaPlaceholder from "../load/EntradaPlaceholder";
import html2canvas from "html2canvas";

const EntradasBar = ({ data }) => {
  const [entradas, setEntradas] = useState(null);
  const fetch = async (setData, params, url) => {
    const response = await apiPrivateAntesala.get(url, { params });
    if (response.status == 201 || response.status == 200) {
      return setData(response.data);
    }

    return setData(null);
  };
  useEffect(() => {
    if (!entradas) {
      return fetch(setEntradas, { sort: "reportes.created_at" }, "/reportes");
    }
  }, []);
  return (
    <div
      className="offcanvas offcanvas-start py-3"
      tabindex="-1"
      id="offcanvasTop-entradas"
      aria-labelledby="offcanvasTopLabel"
    >
      <div className="offcanvas-header py-1" style={{ height: "20px" }}>
        <h5
          className="offcanvas-title Grifter"
          id="offcanvasTopLabel-entradas"
          style={{ fontSize: "16px" }}
        >
          Entradas Adquiridas
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body">
        {entradas
          ? entradas.data.map((entrada, index) => {
              if (entrada.reporte_codigo.length > 0) {
                return entrada.reporte_codigo.map((codigo) => {
                  return (
                    <label
                      className="row p-3 mb-1 entrada-qr btn btn-outline-dark d-flex border-0 shadow-sm"
                      style={{
                        borderRadius: "10px",
                      }}
                      id={`qr-${index}`}
                      title="Descargar entrada"
                    >
                      <div className="col-md-6 mb-1">
                        <div className="my-1">
                          <span className="Grifter">
                            {entrada.evento.nombre}
                          </span>
                        </div>
                        <span
                          className="d-block Grifter"
                          style={{ fontSize: "10px" }}
                        >
                          {entrada.fecha}
                        </span>
                        <span
                          className="d-block Grifter"
                          style={{ fontSize: "10px" }}
                        >
                          {`${entrada.entrada.nombre} x${codigo.cantidad}`}
                        </span>
                      </div>
                      <div className="col-md-6 text-center">
                        <div>
                          <QRCodeCanvas
                            value={codigo.codigo}
                            size={100}
                            level="H"
                          />
                        </div>
                        <div
                          className="d-flex justify-content-center items-align-center Grifter text-muted"
                          style={{ fontSize: "10px" }}
                        >
                          {codigo.codigo}
                        </div>
                      </div>

                      <button
                        className="d-none"
                        onClick={async () => {
                           try {
                                    const response = await apiPrivateAntesala.get('/reportes/download', {
                                        responseType: 'blob',
                                        params: {
                                          precio: entrada.unidad,
                                          entrada: entrada.entrada.nombre,
                                          fecha: entrada.fecha,
                                          evento: entrada.evento.nombre,
                                          titular: entrada.nombre_cliente,
                                          sala: entrada.evento.nombre_sitio,
                                          direccion: `${entrada.evento.direccion} ${entrada.evento.localidad}, ${entrada.evento.provincia}`,
                                          codigo: codigo.codigo
                                        }
                                    });
                            
                                    // Crear un enlace para descargar la imagen
                                    const url = window.URL.createObjectURL(new Blob([response.data]));
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.setAttribute('download', 'ENTRADA-'+codigo.codigo+'.png'); // nombre del archivo
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                    window.URL.revokeObjectURL(url);
                                } catch (error) {
                                    console.error('Error al descargar la imagen:', error);
                                }
                        }}
                      ></button>
                    </label>
                  );
                });
              }
              return (
                <label
                  className="row p-3 mb-1 entrada-qr btn btn-outline-dark d-flex"
                  style={{ borderRadius: "10px", border: "1px solid #d0552a" }}
                  id={`qr-${index}`}
                  title="Descargar entrada"
                >
                  <div className="col-md-12 mb-1">
                    <div className="my-1">
                      <span className="Grifter">{entrada.evento.nombre}</span>
                    </div>
                    <span
                      className="d-block Grifter"
                      style={{ fontSize: "13px" }}
                    >
                      {entrada.fecha}
                    </span>
                    <span
                      className="d-block Grifter"
                      style={{ fontSize: "13px" }}
                    >
                      {`${entrada.entrada.nombre} x${entrada.cantidad}`}
                    </span>
                  </div>
                  <div className="col-md-12 text-center">
                    <div>
                      <QRCodeCanvas
                        value={entrada.codigo}
                        size={130}
                        level="H"
                        imageSettings={{
                          src: "/assets/img/marca/antesala-logo.svg", // ruta de la imagen
                          x: undefined,
                          y: undefined,
                          height: 20,
                          width: 30,
                          excavate: true, // deja un hueco detrás de la imagen
                        }}
                      />
                    </div>
                    <div
                      className="d-flex justify-content-center items-align-center Grifter text-muted"
                      style={{ fontSize: "16px" }}
                    >
                      {entrada.codigo}
                    </div>
                  </div>

                  <button
                    className="d-none"
                    onClick={async () => {
                      const qr = document.getElementById(`qr-${index}`);
                      const canvas = await html2canvas(qr);
                      const link = document.createElement("a");
                      link.href = canvas.toDataURL("image/png");
                      link.download = "captura.png";
                      link.click();
                    }}
                  ></button>
                </label>
              );
            })
          : [1, 2, 3, 4].map(() => <EntradaPlaceholder />)}

        <div className="d-flex ">
          {entradas
            ? entradas.links.map((link) => {
                if (link.label == "&laquo; Previous") {
                  return (
                    <label
                      className={`btn btn-outline-dark ${
                        link.active ? "active" : ""
                      } ${link.url ? "" : "disabled"}`}
                    >
                      <i class="bi bi-arrow-left"></i>
                    </label>
                  );
                }
                if (link.label == "Next &raquo;") {
                  return (
                    <label
                      className={`btn btn-outline-dark ${
                        link.active ? "active" : ""
                      } ${link.url ? "" : "disabled"}`}
                    >
                      <i class="bi bi-arrow-right"></i>
                    </label>
                  );
                }

                return (
                  <label
                    className={`btn btn-outline-dark ${
                      link.active ? "active" : ""
                    } ${link.url ? "" : "disabled"}`}
                  >
                    {link.label}
                  </label>
                );
              })
            : ""}
        </div>
      </div>
    </div>
  );
};

export default EntradasBar;
